import PropTypes from 'prop-types';
import { Button } from 'antd';

import './Footer.less';

function Footer({ onClick, disabled }) {
  return (
    <div className="footer">
      <Button className="stark-button-bordered" type="primary" onClick={onClick} data-testid="footer__primary-action" disabled={disabled}>
        START FREE TRIAL
      </Button>
    </div>
  );
}

Footer.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Footer;
